export default __webpack_public_path__ + "static/exp5-8ba6f533e35be397294b8750f968b344.webp";